import { toast } from "react-toastify";
import { GetAllPurchaseOrdersApi } from "../../../Api/Operations/PurchaseOrders";

/**
 * Purchase Orders Redux Actions
 * Pattern: Action creator + Async thunk with error handling
 */

// Synchronous Action Creator
export const GetAllPurchaseOrders = (data) => {
  return {
    type: "get_all_purchase_orders",
    payload: data,
    loader: false,
  };
};

// Async Thunk - Fetch all purchase orders
export function getallPurchaseOrders(projectId) {
  return async (dispatch) => {
    try {
      const result = await GetAllPurchaseOrdersApi(projectId);

      if (result.data?.IsSuccess === true) {
        dispatch(GetAllPurchaseOrders(result.data.Data));
      } else {
        toast.error(result.data?.Message || "Failed to fetch purchase orders");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching purchase orders!");
    }
  };
}
